import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { entitiesBulkload } from '../../../store/entities/entities.actions';
import { processEntities } from '../../../store/entities/entities.bulkload';
import { useFulfillmentPlannerContext } from '../../../fulfillment-planner/context';

export const useUpdateEntitiesFulfillmentPlans = () => {
  const dispatch = useDispatch();

  const updateEntities = useCallback(
    (fulfillmentPlans) => {
      dispatch(entitiesBulkload(processEntities({ fulfillmentPlans })));
    },
    [dispatch],
  );

  return updateEntities;
};

export const useUpdateCswWithEntity = () => {
  const { syncCswWithUpdatedEntity } = useFulfillmentPlannerContext();

  const updateCSW = useCallback(
    (fulfillmentPlan) => {
      syncCswWithUpdatedEntity(fulfillmentPlan);
    },
    [syncCswWithUpdatedEntity],
  );

  return updateCSW;
};
